import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle2, Loader2, Package } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const formatINR = (n) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n || 0);

export default function OrderSuccessPage() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/orders/${orderId}`).then((r) => r.json()).then(setOrder).catch(() => {}).finally(() => setLoading(false));
  }, [orderId]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-cream to-white py-12" data-testid="order-success-page">
      <div className="container mx-auto px-4 max-w-2xl">
        <div className="bg-white rounded-2xl border border-amber-100 p-8 text-center">
          <CheckCircle2 className="w-16 h-16 text-emerald-500 mx-auto mb-4" />
          <h1 className="font-serif text-3xl font-bold text-foreground mb-2">Order Confirmed!</h1>
          <p className="text-muted-foreground mb-6">Thank you for your order. We've received it and will start preparing it right away.</p>

          {loading ? (
            <Loader2 className="w-6 h-6 animate-spin text-amber-500 mx-auto" />
          ) : order ? (
            <div className="text-left">
              <div className="bg-amber-50 rounded-xl p-4 mb-5 flex items-center justify-between">
                <div>
                  <p className="text-xs text-slate-500">Order Number</p>
                  <p className="font-bold text-lg" data-testid="order-number">{order.order_number}</p>
                </div>
                <span className="text-xs px-3 py-1 rounded-full bg-emerald-100 text-emerald-700 uppercase">{order.status}</span>
              </div>
              <div className="border border-slate-100 rounded-xl divide-y divide-slate-100 mb-4">
                {order.items?.map((it, i) => (
                  <div key={i} className="flex items-center gap-3 px-4 py-3">
                    {it.image && <img src={it.image} alt="" className="w-10 h-10 rounded object-cover" />}
                    <span className="flex-1 text-sm">{it.name} × {it.quantity}</span>
                    <span className="text-sm font-medium">{formatINR(it.price * it.quantity)}</span>
                  </div>
                ))}
                <div className="flex justify-between px-4 py-3 font-bold">
                  <span>Total ({order.payment_method === 'cod' ? 'Cash on Delivery' : 'Paid'})</span>
                  <span className="text-gold">{formatINR(order.total)}</span>
                </div>
              </div>
              <p className="text-sm text-slate-500 flex items-center gap-2"><Package className="w-4 h-4" /> Delivering to {order.shipping_address?.city}, {order.shipping_address?.state} - {order.shipping_address?.pincode}</p>
            </div>
          ) : (
            <p className="text-muted-foreground">Order details unavailable.</p>
          )}

          <Link to="/products" className="inline-block mt-8 gold-gradient text-white font-semibold rounded-lg px-6 py-3 text-sm" data-testid="continue-shopping">
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
}
